import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getLeadConversionReport } from "../../services/reports2.services";

export const fetchFreshToEnquiryReport = createAsyncThunk(
  "freshToEnquiry/fetchReport",
  async (_, { rejectWithValue }) => {
    try {
      const data = await getLeadConversionReport("fresh_to_enquiry");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const freshToEnquirySlice = createSlice({
  name: "freshToEnquiry",
  initialState: {
    data: [],
    list: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFreshToEnquiryReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchFreshToEnquiryReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data;
        state.list = action.payload.list;
      })
      .addCase(fetchFreshToEnquiryReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default freshToEnquirySlice.reducer;
